export default {
    scheduled_actions_entity_name: "Entity Name",
    scheduled_actions_name: "Name",
    scheduled_actions_action: "Action",
    scheduled_actions_schedule_on: "Schedule On",
    scheduled_actions_executed: "Executed",
    scheduled_actions_created_on: "Created On",
    scheduled_actions_created_by: "Created By",
    scheduled_actions_title: "Scheduled Actions",
}